import React from "react";
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Home, BuildingHospital, CaretRight, TrendingDown, Notebook, List, ClipboardCheck } from 'tabler-icons-react';
import leftArrow from '../images/leftArrow.png'
import righttArrow from '../images/rightArrow.png'
import btnHome from '../images/btnHomeIcon.png'

const GeneralQuestion = () => {
    return (
        <div className="topicSection">

            {/* HOME BUTTON SECTION */}
            <div className="btnHomeSection bounce-in-fwd10">
                <button type="button" className="btnCircle">
                    <img src={btnHome} alt="Date" height="50" width="50" /><br />
               HOME
            </button>
            </div>


            <div className="headerSub">
                <div className="headerSubTitle scale-in-center">
                    <p>
                        PLEASE ANSWER THE QUESTIONNAIRE
                    </p>
                </div>
            </div>

            <div className="headerName">
                <div className="headerTitle slide-in-top">
                    <div className="iconHospital"></div>
                    <div className="iconNameTitle">GENERAL VISIT</div>
                </div>
            </div>


            {/* MAIN CONTENT SECTION */}
            <div className="contentPage">

                {/* BREADCRUMBS */}
                <div className="breadcrumbs">
                    <ul>
                        <li className="fcolorGreen fade-in-left2"><Home size={50} strokeWidth={2} color={'green'} /> <span className="crumHome">HOME </span>
                            <TrendingDown size={25} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen fade-in-left3"><BuildingHospital size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 1</i></b>
                            <br />
                         GENERAL VISIT <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorRed fade-in-left4"><Notebook size={40} strokeWidth={2} color={'red'} />
                            <b><i> Step 2</i></b> <br />
                        REGISTRATION <CaretRight size={40} strokeWidth={2} color={'red'} />
                        </li>
                        <li className="fcolorGray fade-in-left5"><List size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                        SUMMARY <CaretRight size={40} strokeWidth={2} color={'gray'} />
                        </li>
                        <li className="fcolorGray fade-in-left6"><ClipboardCheck size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 4</i></b> <br />
                        COMPLETE

                        {/* For White space */}
                            <CaretRight size={40} strokeWidth={2} color={'transparent'} />
                        </li>
                    </ul>
                </div>


                {/* QUESTIONNAIRE SECTION  */}
                <div className="questionSection">
                    <h2 className="fade-in-tl5"><b>Hi, <span>Tan Ah Meng</span></b></h2>
                    <br />

                    <div className="questionList">
                        <Form.Group as={Row} controlId="formGroupQuestion" className="fade-in-bottom2">
                            <Col md="8">
                                <span className="qnumber">Q1:</span>
                                <span className="qMain"> ARI Symptom</span>
                                <p>Are you currently having any ARI symptoms?</p>
                            </Col>
                            <Col md="2" className="YesRadio YesRadioT">
                                <label for="opt1" className="radio">
                                <input type="radio" name="rdo" id="opt1" className="hidden CirclOp" />
                                <span className="label">YES</span></label> 
                            </Col>
                            <Col md="2" className="NoRadio NoRadioT"> 
                                <label for="opt2" className="radio">
                                <input type="radio" name="rdo" id="opt2" className="hidden" />
                                <span className="label"></span>NO</label>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formGroupQuestion" className="fade-in-bottom3">
                            <Col sm="8">
                                <span className="qnumber">Q2:</span>
                                <span className="qMain"> Travel Info</span>
                                <p>Have you travelled or returned from abroad (outside Singapore) in the last 14 days?</p>
                            </Col>
                            <Col md="2" className="YesRadio YesRadioT">
                                <label for="opt3" className="radio">
                                <input type="radio" name="rdotwo" id="opt3" className="hidden" />
                                <span className="label"></span>YES</label> 
                            </Col>
                            <Col md="2" className="NoRadio NoRadioT"> 
                                <label for="opt4" className="radio">
                                <input type="radio" name="rdotwo" id="opt4" className="hidden" />
                                <span className="label"></span>NO</label>
                            </Col> 
                        </Form.Group> 

                    </div>

                </div>


                <div className="footerBtnLeft fade-in-left7">
                    <button type="button" className="btnCircle ">
                        <img src={leftArrow} alt="Arrow Left" height="50" width="50" /><br />
                        BACK
                    </button>
                </div>

                <div className="footerBtnRight fade-in-left8 btnPosEnd3">
                    <button type="button" className="btnCircle">
                        <img src={righttArrow} alt="Arrow Right" height="50" width="50" /><br />
                        NEXT
                    </button>
                </div>


            </div>
        </div>
    );
};

export default GeneralQuestion;